import * as React from "react";
import { Component } from "react";
import CreateSensorGroupForm from "Forms/Composite/CreateSensorGroupForm";
import ModalPanel from "Panels/ModalPanel";
import Services from "Services/Platform/Services";

interface CreateSensorGroupModalPanelProps {
    parentGroupId: string;
    creationAreaName?: string;
    shouldBeShown: boolean;
    onClose(): void;
    onCreate(): void;
}

interface CreateSensorGroupModalPanelState {
    isSaving: boolean;
}

export default class CreateSensorGroupModalPanel extends Component<CreateSensorGroupModalPanelProps, CreateSensorGroupModalPanelState> {
    constructor(props: CreateSensorGroupModalPanelProps) {
        super(props);
        this.state = { isSaving: false };
    }

    render() {
        return (
            <ModalPanel
                title="Create sensor group"
                titleAlignment="centre"
                shouldBeShown={this.props.shouldBeShown}
                onClose={() => this.onClose()}
                content={this.form()}
            />
        );
    }

    private form() {
        const { creationAreaName } = this.props;

        return (
            <>
                {creationAreaName && <div style={{ color: "#666", fontSize: "12px", marginBottom: 14 }}>
                    New sensors and groups are created in: <strong>{creationAreaName}</strong>
                </div>}
                <CreateSensorGroupForm
                    isSaving={this.state.isSaving}
                    onClose={() => this.onClose()}
                    onCreate={groupName => this.onCreate(groupName)}
                />
            </>
        );
    }

    private onClose() {
        if (!this.state.isSaving) this.props.onClose();
    }

    private async onCreate(groupName: string) {
        const { onCreate, parentGroupId } = this.props;

        if (!Services.userCanEdit()) {
            this.props.onClose();
            return;
        }

        this.setState({ isSaving: true });

        try {
            await Services.SensorGroups.addSensorGroup(groupName, parentGroupId);
            await onCreate();
        } catch (error) {
            // Keep a rejected API request from escaping the button handler and
            // leaving the modal in an unusable state.
            console.error("Unable to create sensor group", error);
        } finally {
            this.setState({ isSaving: false });
        }
    }
}
